import { useState } from 'react';
import './index.scss';
import { useMediaQuery } from 'react-responsive';
import Client1 from '@/assets/image/home/client1.png';
import Client2 from '@/assets/image/home/client2.png';
import MobileClient3 from '@/assets/image/home/client3.png';
import MobileClient4 from '@/assets/image/home/client4.png';
import MobileClient5 from '@/assets/image/home/client5.png';
import MobileClient6 from '@/assets/image/home/client6.png';
import Client3 from '@/assets/image/home/client3_new.png';
import Client4 from '@/assets/image/home/client4_new.png';
import Client5 from '@/assets/image/home/client5_new.png';
import Client6 from '@/assets/image/home/client6_new.png';
import DisplayText from '../../../../components/DisplayText';

const testimonialsData = [
  // {
  //   id: 1,
  //   name: 'Christopher Nixson Cox',
  //   title: 'Board Member, Founder and CEO',
  //   quote: '“ I backed Vishwa because institutions won’t move without control and proof, and that’s exactly what’s being built. ”',
  //   image: Client1
  // },
  // {
  //   id: 2,
  //   name: 'Vishesh C.',
  //   title: 'Risk Management, Ex. MakerDao',
  //   quote: '“ Institutional adoption depends on risk controls, not hype. Vishwa makes agent actions provable and auditable without revealing intent. ”',
  //   image: Client2,
  // },
  {
    id: 3,
    name: 'Canice Wu',
    title: 'SVP, Salesforce & Oracle',
    quote: '“Compliance and reliability must be enforced on-chain.”',
    image: Client3,
    mobileImg: MobileClient3
  },
  {
    id: 4,
    name: 'Chi Zhang',
    title: 'CEO & Co-founder at KITE AI',
    quote: '“Agentic payments require infrastructure that scales to real financial systems.”',
    image: Client4,
    mobileImg: MobileClient4
  },
  {
    id: 5,
    name: 'Scott Moore',
    title: 'Co founder, Gitcoin',
    quote: '“Execution must be verifiable.”',
    image: Client5,
    mobileImg: MobileClient5
  },
  {
    id: 6,
    name: 'Michael Heinrich',
    title: 'Co-Founder 0G Labs',
    quote: '“Agentic finance is an infrastructure problem.”',
    image: Client6,
    mobileImg: MobileClient6
  }
];

const Testimonials = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={`testimonials w-1340 mx-auto ${isMobile ? 'pt-[48px] pb-[72px]' : 'pt-[200px] pb-[120px]'}`}>
      <div className={`testimonials-header mb-[54px] ${isMobile?`w-[200px]` : null}`}>
        <DisplayText fullText="Built alongside leaders across finance and infrastructure" />
      </div>
      
      <div className={`testimonials-grid ${isMobile ? 'grid-cols-1' : 'grid-cols-4'}`}>
        {testimonialsData.map((person) => (
          <div 
            key={person.id} 
            className={`testimonial-card`}
          >
            <div className="testimonial-image">
              <img src={isMobile?person.mobileImg:person.image} alt={person.name} />
            </div>
            
            <div className="testimonial-info w-[224px]">
              <h3 className="testimonial-name">{person.name}</h3>
              <p className="testimonial-title">{person.title}</p>
            </div>
            
            <p className="testimonial-quote w-[230px]">{person.quote}</p>
            
            {/*<div className="testimonial-arrow">*/}
            {/*  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="13" viewBox="0 0 54 13" fill="none">*/}
            {/*    <path d="M46.8423 0.377252C47.3276 -0.125751 48.1308 -0.125751 48.616 0.377252L53.636 5.58072C54.1213 6.08372 54.1213 6.91628 53.636 7.41928L48.616 12.6227C48.1308 13.1258 47.3276 13.1258 46.8423 12.6227C46.6089 12.3779 46.478 12.0476 46.478 11.7035C46.478 11.3593 46.6089 11.029 46.8423 10.7842L49.7204 7.80087H1.255C0.568935 7.80087 -2.28776e-08 7.21114 0 6.5C2.28776e-08 5.78886 0.568935 5.19913 1.255 5.19913H49.7204L46.8423 2.21581C46.6089 1.97101 46.478 1.64071 46.478 1.29653C46.478 0.952356 46.6089 0.622054 46.8423 0.377252Z" fill="#999999"/>*/}
            {/*  </svg>*/}
            {/*</div>*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
